module.exports = __webpack_public_path__ + "static/media/whats.70f3d23c.svg";